<template>
  <Overlay v-if="isLoading" />
  <iframe id="adas-inspection-iframe" :src="iframeUrl" class="custom-iframe" frameborder="0"></iframe>
</template>
<script>
import { mapState } from 'pinia'
import { authStore } from '@/stores/auth'
import { inspectionStore } from '@/stores/inspection'
import Overlay from '@/components/utilities/elements/Overlay.vue'
export default {
  name: 'AdasInspection',
  components: {
    Overlay
  },
  props: {
    tab: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      guid: 'AA782740-D4B6-40AE-88EF-6F8E2660DBB2',
      baseUrl: window.config ? window.config.adasMapUrl : '',
      isInit: true,
      isLoading: true
    };
  },
  mounted() {
    this.isLoading = true
    this.isInit = true
    console.log('Viewing ADAS Map', {
      baseUrl: this.baseUrl,
      t: this.token,
      inspection: this.inspection
    })
    window.addEventListener('message', this.handleMessage)
  },
  computed: {
    ...mapState(authStore, ['token']),
    ...mapState(inspectionStore, ['inspection']),
    iframeUrl() {
      if ( this.inspection && this.inspection.adasInspection)
      {
        return `${this.baseUrl}/blueprint?t=${this.token}&adasInspection=${this.inspection.adasInspection}&v=${Date.now()}`
      } 
    }
  },
  methods: {
    handleMessage(event) {
      if (event.data.type === 'ready' && this.isInit) {
        this.isInit = false
        console.log('ADAS Map is ready, sending initialization...')
        const iframe = document.getElementById('adas-inspection-iframe');
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage(
            {
              id: this.guid,
              type: 'triggerAction',
              action: 'initialize',
              payload: {
                adasInspectionId: this.inspection.adasInspection,
                token: this.token
              }
            },
            '*'
          )
        }
      } else if (event.data.type === 'isLoaded') {
        this.isLoading = false
      }
    },
    gotoProviders() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        console.log('Triggering ShowTab() in ADAS Map')
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'showTab',
            payload: {
              tab: 'Provider'
            }
          },
          '*'
        )
      }
    },
    showRepairLines() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'showRepairLines',
            payload: null
          },
          '*'
        )
      }
    },
    scrubRepairData() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'scrubRepairData',
            payload: null
          },
          '*'
        )
      }
    },
    emailReport() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'emailReport',
            payload: null
          },
          '*'
        )
      }
    },
    showReport() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'showReport',
            payload: null
          },
          '*'
        )
      }
    },
    pushReportToCCC() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'pushToCCC',
            payload: null
          },
          '*'
        )
      }
    },
    sendToCalCopilot() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            type: 'triggerAction',
            action: 'sendToCalCopilot',
            payload: null
          },
          '*'
        )
      }
    },
    completeInspection() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'completeInspection',
            payload: null
          },
          '*'
        )
      }
    },
    saveInspection(closeIt) {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'saveInspection',
            payload: {
              closeIt: closeIt
            }
          },
          '*'
        )
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  unmounted() {
    this.isLoading = true
    this.isInit = true
  }
};
</script>
<style lang="scss" scoped>
.custom-iframe {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  height: 650px;
}
</style>